import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { deleteWrittenTest } from "../../api/training.deprecated";
import Confirm from "../../components/Confirm";
import request from "../../api/request";

export async function getSSID() {
  const ssid = await request(`/sts`);
  return ssid;
}

const downloadWrittenTest = async (fileName) => {
  const ssid = await getSSID();
  window.open(`${process.env.REACT_APP_API_URL}/files/download/written-test/${fileName}?ssid=${ssid}`, "_blank");
};

const WrittenTestTrainingInfo = ({ match, history }) => {
  const { t } = useTranslation();
  const trainingId = match.params.trainingId;
  const userId = match.params.userId;

  const [usersWrittenTest, setUsersWrittenTest] = useState([]);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteWrittenTest(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const usersWrittenTest = await request(`/users-training/user-written-test/${trainingId}`);
      setUsersWrittenTest(usersWrittenTest.filter((el) => el.user_id == userId));
    })();
  }, [refresh, trainingId, userId]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.written_test")}</Typography>
      {usersWrittenTest ? (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("training_pages.perc_passed") },
            { title: t("completed_date") },
            { title: t("comment") },
            { title: t("training_pages.download") },
          ]}
          //writtenTestId
          renderChildren={(userWrittenTest, index) => (
            <TableRow key={index}>
              <TableCell>{userWrittenTest.user_id}</TableCell>

              <TableCell>{userWrittenTest.valid_answer}</TableCell>
              <TableCell>{new Date(userWrittenTest.completed_date).toLocaleDateString("de-CH")}</TableCell>
              <TableCell>{userWrittenTest.comment}</TableCell>

              <TableCell>
                {userWrittenTest.file_name ? (
                  <>
                    <Button
                      title={t("training_pages.download_written_test")}
                      icon={<GetAppIcon />}
                      onClick={() => downloadWrittenTest(userWrittenTest.file_name)}
                    />
                  </>
                ) : null}
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "company_name"]}
          pagination
          items={usersWrittenTest}
        />
      ) : null}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("training_pages.delete_written_test")} onConfirm={confirmDeleteModal}>
          <p>{t("training_pages.delete_written_test_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default WrittenTestTrainingInfo;
